module.exports = __webpack_public_path__ + "static/img/head-bg.3ea59efd.png";